import { render, staticRenderFns } from "./BailiffEdit.vue?vue&type=template&id=0d632e5c&"
import script from "./BailiffEdit.vue?vue&type=script&lang=js&"
export * from "./BailiffEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports